import translate from '@/utils/translate';
import {RecruitmentFilterStatus, RecruitmentSortBy} from './types';

/**
 * Human-readable labels for recruitment filter statuses (includes 'removed')
 */
export function getStatusLabels(): Record<RecruitmentFilterStatus, string> {
  return {
    invited: translate('Invited'),
    pending_social_linking: translate('Pending Social Linking'),
    pending_vetting: translate('Pending Vetting'),
    vetting_in_progress: translate('Vetting in Progress'),
    vetting_failed: translate('Vetting Failed'),
    active: translate('Active'),
    removed: translate('Removed'),
  };
}

/**
 * Human-readable labels for sort fields
 */
export function getSortLabels(): Record<RecruitmentSortBy, string> {
  return {
    created_at: translate('Recruited Date'),
    status: translate('Status'),
    name: translate('Name'),
    email: translate('Email'),
  };
}
